"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cleanContent;
var _dompurify = _interopRequireDefault(require("dompurify"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function cleanContent(content) {
  _dompurify.default.addHook('beforeSanitizeAttributes', function (node) {
    // Remove the node in case it is empty
    if (!node.hasChildNodes() && !node.textContent) {
      node.remove();
    }
  });
  return _dompurify.default.sanitize(content, {
    ALLOWED_TAGS: ['p', 'i', 'b', 'i', 'u', 'br', 'em', 'strong', 'a', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'article', 'aside', 'header', 'footer', 'main', 'section', 'blockquote', 'div', 'span', 'sub', 'sup'],
    ALLOWED_ATTR: ['href', 'target']
  });
}